import { render, staticRenderFns } from "./modifyFee.vue?vue&type=template&id=a80b2c9e&scoped=true"
import script from "./modifyFee.vue?vue&type=script&lang=js"
export * from "./modifyFee.vue?vue&type=script&lang=js"
import style0 from "./modifyFee.vue?vue&type=style&index=0&id=a80b2c9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80b2c9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a80b2c9e')) {
      api.createRecord('a80b2c9e', component.options)
    } else {
      api.reload('a80b2c9e', component.options)
    }
    module.hot.accept("./modifyFee.vue?vue&type=template&id=a80b2c9e&scoped=true", function () {
      api.rerender('a80b2c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/modifyFee.vue"
export default component.exports